import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Application } from '@core/models/application';
import { ConfigService } from './config.service';
import { LiveSession } from '@core/models/live-session';

@Injectable({
	providedIn: 'root'
})
export class CoreHttpService {

	constructor(private http: HttpClient,
		private configService: ConfigService) {

	}

	public getApplicationData(): Observable<Application> {

		return this.http.get<Application>(`${this.configService.contentEndpoint}/application`);
	}

	public getLiveSessions(): Observable<LiveSession[]> {

		return this.http.get<LiveSession[]>(`${this.configService.contentEndpoint}/live`);
	}
}